export default {"src":"/_next/static/media/sib.f8061631.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};